"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Character;

function Character() {}

Character.isWhitespace = function (c) {
  return c <= 32 && c >= 0 || c == 127;
};

Character.toUpperCase = function (c) {
  return c.toUpperCase();
};